// src/APP/routes/index.jsx
import React from "react";
import {  Routes, Route } from "react-router-dom";

import Home from "../pages/Home";
import About from "../pages/About";
import Navbar from "../partials/Navbar";
import Contact from "../pages/Contact";
import Footer from "../partials/Footer";


import CareerPage from "../pages/CareerPage";
import CollaborationsPage from "../pages/Collaborations";
import AchievementPage from "../pages/AchievementPage";
import MUEFoundersPage from "../pages/Founder";
import ProductsPipelinePage from "../pages/ProductsPipe";
import TechnologyRDPage from "../pages/TechnologyRDPage";
import InvestorsPage from "../pages/For_investors";
import Addpages from "../pages/OurTechnology";
import OurPartner from "../pages/ourPanter";
import NewsUpdatesBlogsPage from "../pages/News";
import Productpages from "../pages/Productpages";
import BlogPostPage from "../pages/Blog1";
import BlogPostPage2 from "../pages/Blog2";
import BlogPostPage3 from "../pages/Blog3";
import BlogPostPage4 from "../pages/Blog4";
import BlogPostPage5 from "../pages/blog5";
import BlogPostPage1 from "../pages/Blog1";
import FeedbackForm from "../Fromfeeback/pages/FeedbackForm";
import SetuEventPage from "../pages/SetuEventPage";

export default function AppRoutes() {
  return (
   
      <>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          
          {/**<Route path="/about" element={<About />} /> */}
          {/* About Routes */}
        <Route path="/about" element={<About />} />
        <Route path="/founders" element={<MUEFoundersPage />} />
        <Route path="/Career" element={<CareerPage />} />
        <Route path="/collaborations" element={<CollaborationsPage />} />
        <Route path="/achievements" element={<AchievementPage />} />

        <Route path="/event" element={<SetuEventPage />} />


          <Route path="/Contact" element={<Contact />} />
            <Route path="/Products" element={< Productpages/>} />
           <Route path="/news" element={<NewsUpdatesBlogsPage/>} />
           <Route path="/Career" element={<CareerPage/>} />

           {/* add some page more  */}
            <Route path="/talks" element={<Contact />} />
            <Route path="/OurTechnology" element={<TechnologyRDPage/>} />
            <Route path="/investors" element={<InvestorsPage />} />
            <Route path="/Addpages" element={<Addpages />} />{/** our techno navbar link */}
            <Route path="/partners" element={<OurPartner />} />
            <Route path="/feebback" element={<FeedbackForm/>} />
              {/* ✅ This page: your BlogPostPage UI BlogPostPage2*/}
        {/* <Route path="/blog/:id" element={<BlogPostPage />} /> */}
        <Route path="/BlogPostPage1" element={<BlogPostPage1 />} />

                 <Route path="/BlogPostPage2" element={<BlogPostPage2 />} />
                  <Route path="/BlogPostPage3" element={<BlogPostPage3 />} />
                   <Route path="/BlogPostPage4" element={<BlogPostPage4 />} />
                     <Route path="/BlogPostPage5" element={<BlogPostPage5 />} />
        </Routes>
        <Footer/>
      </>
    
  );
}
